// External Dependencies
import Button, { type ButtonProps } from '@mui/material/Button';

// Local Typings
export interface EnhancedButtonProps extends ButtonProps {
  target?: string;
}

// Component Definition
const EnhancedButton = ({
  children,
  className,
  color = 'primary',
  variant = 'contained',
  ...otherProps
}: EnhancedButtonProps): JSX.Element => {
  return (
    <Button
      className={className}
      color={color}
      variant={variant}
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default EnhancedButton;
